angular.module('storefrontApp')
    .controller('loginController', ['$scope', function ($scope) {
        $scope.showResetPasswordDialog = function () {
            $scope.resetPasswordDialogVisible = true;
        };

        $scope.closeResetPasswordDialog = function () {
            $scope.resetPasswordDialogVisible = false;
        };
    }]);
